export default __webpack_public_path__ + "static/media/eye.cffc060a.svg";